import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/esm/objectWithoutProperties";
/**
 *
 * Input
 *
 */

import React from 'react';

var Input = function Input(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      name = _ref.name,
      type = _ref.type,
      forwardRef = _ref.forwardRef,
      isControlled = _ref.isControlled,
      validate = _ref.validate,
      extraProps = _objectWithoutProperties(_ref, ["className", "disabled", "name", "type", "forwardRef", "isControlled", "validate"]);

  return React.createElement("input", _extends({
    className: className,
    disabled: disabled,
    name: name,
    type: type,
    ref: forwardRef
  }, extraProps));
};

Input.defaultProps = {
  className: '',
  disabled: false,
  forwardRef: undefined
};
Input.displayName = 'Input';
export default Input;